import { removeEmptyStrings } from './removeEmptyStrings';
import { transformFilterArraysToString } from './table';

export const prepareFilterParams = (filters: Record<string, unknown>) => {
  return removeEmptyStrings(transformFilterArraysToString(filters));
};
